import { maunaSpaceAPI } from '@/api';
import CommonUserListContainer from '@/components/common/CommonUserListContainer';
import MaunaHeader from './MaunaHeader';
import { createColumnHelper, ColumnDef } from '@tanstack/react-table';

interface MaunaUserDataType {
  uid: string;
  phone: string;
  name: string;
  passedSpace: string;
  passedPoint: string;
  createdAt: string;
}

const columnHelper = createColumnHelper<MaunaUserDataType>();

const getColumns = (): ColumnDef<MaunaUserDataType, any>[] => {
  const baseColumns = [
    columnHelper.accessor('uid', {
      header: 'UID',
      cell: (info) => info.getValue(),
    }),
    columnHelper.accessor('phone', {
      header: '전화번호',
      cell: (info) => info.getValue(),
    }),
    columnHelper.accessor('name', {
      header: '이름',
      cell: (info) => info.getValue() || '-',
    }),
    columnHelper.accessor('passedSpace', {
      header: '통과 공간',
      cell: (info) => info.getValue() || '-',
    }),
    columnHelper.accessor('passedPoint', {
      header: '통과 포인트',
      cell: (info) => {
        const value = info.getValue() || '-';
        const text = String(value);
        if (text === '-') return '-';
        const truncated = text.length > 20 ? `${text.slice(0, 20)}...` : text;
        return (
          <span
            title={text}
            onClick={() => window.alert(text)}
            style={{ cursor: 'pointer' }}
          >
            {truncated}
          </span>
        );
      },
    }),
    columnHelper.accessor('createdAt', {
      header: '가입 날짜',
      cell: (info) => new Date(info.getValue()).toLocaleDateString(),
    }),
  ];

  return baseColumns.filter(Boolean) as ColumnDef<MaunaUserDataType, any>[];
};

const MaunaUserContainer = () => {
  return (
    <CommonUserListContainer<MaunaUserDataType>
      HeaderComponent={MaunaHeader}
      queryKey="getUsersMauna"
      queryFn={() =>
        maunaSpaceAPI.getUsers({
          code: import.meta.env.VITE_SECRET_API_KEY,
        })
      }
      columns={getColumns}
    />
  );
};

export default MaunaUserContainer;
